import React, { useCallback } from 'react';

import PropTypes from 'prop-types';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

export const CountryDropdownMenuItem = ({ onClick, countryCode, countryName, ...rest }) => {
  const selectCountry = useCallback(() => {
    onClick(countryCode);
  }, [countryCode, onClick]);

  return (
    <DropdownMenuItem {...rest} onClick={selectCountry}>
      {countryName}
    </DropdownMenuItem>
  );
};

const getDropdownMenuItemPropTypes = () => {
  const dropdownMenuItemPropTypes = { ...DropdownMenuItem.propTypes };
  delete dropdownMenuItemPropTypes.children;
  return dropdownMenuItemPropTypes;
};

CountryDropdownMenuItem.propTypes = {
  ...getDropdownMenuItemPropTypes(),
  countryCode: PropTypes.string.isRequired,
  countryName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
